export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9328.0ea7a8d3.jpg";